/* Determinate progress track.
 *
 * The Figma draws a 3px track containing an 8px fill offset by
 * `calc(50% + 0.5px)`, clipped by the track's overflow — so the fill is
 * cropped and sits half a pixel off centre, and it is rounded on its left edge
 * only. That is a layer-height mistake, not a design intent: implemented here
 * as a 3px fully-rounded fill inside a 3px track. */

.track {
  height: 3px;
  width: 100%;
  border-radius: var(--radius-round);
  background: var(--bg-tertiary);
  /* Clips the fill's right radius at 100% so the bar reads as a filled track
   * rather than a pill floating in one. */
  overflow: hidden;
}

.fill {
  height: 100%;
  border-radius: var(--radius-round);
  background: var(--transfer-accent);
  /* Width is the only animated property — transform would blur the rounded cap
   * and `width` on a 3px bar is cheap. Held to a short duration so the bar
   * never appears ahead of the real transfer. */
  transition: width 200ms ease-out;
}

@media (prefers-reduced-motion: reduce) {
  .fill {
    transition: none;
  }
}
